<template>
    <el-row type="flex" class="model-table-search btn-bg" :style="{marginBottom: !isCloseFlag ? '30px' : '0'}">
        <el-col id="search-input-guide" :span="list.searchLeftSpan || 20">
            <el-row class="search-box">
                <el-col
                    :span="data.span"
                    v-for="(data, index) in list.searchTxt"
                    v-show="data.isClose ? isCloseFlag : true"
                    :key="index"
                >
                    <div
                        class="search"
                        v-if="!data.type || data.type === 'input'"
                    >
                        <el-input
                            class="inputBorderV3"
                            :disabled="data.disabled"
                            :clearable="data.clearable"
                            v-model.trim="searchData[data.value]"
                            :placeholder="data.name"
                        ></el-input>
                    </div>
                    <div class="search" v-if="data.type === 'datePicker'">
                        <el-date-picker
                            class="datePickBorderV3"
                            v-model="searchData[data.value]"
                            :clearable="data.clearable"
                            :picker-options="
                                data.pickerOptions || pickerOptions
                            "
                            prefix-icon="el-icon-date"
                            type="datetimerange"
                            align="left"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            :disabled="data.disabled"
                            :range-separator="searchData[data.value] ? '-' : ''"
                            :start-placeholder="
                                data.name ||
                                $translate('lang.E3202101270023', {
                                    defaultText: '开始日期'
                                })
                            "
                            :end-placeholder="
                                data.name
                                    ? ''
                                    : $translate('lang.E3202101270024', {
                                          defaultText: '结束日期'
                                      })
                            "
                            size="mini"
                        ></el-date-picker>
                    </div>
                    <div class="search" v-if="data.type === 'date'">
                        <el-date-picker
                            v-model="searchData[data.value]"
                            :disabled="data.disabled"
                            class="search-box-datePick"
                            :value-format="'yyyy-MM-dd HH:mm:ss'"
                            :placeholder="data.name"
                            :clearable="data.clearable"
                            align="left"
                            size="mini"
                        >
                        </el-date-picker>
                    </div>
                    <!-- TODO 20230906选择器多选，以及向上发动作 -->
                    <div class="search" v-if="data.type === 'select'">
                        <el-select
                            v-model="searchData[data.value]"
                            :placeholder="data.name"
                            :disabled="data.disabled"
                            :clearable="data.clearable || false"
                            filterable
                            :multiple="data.multiple || false"
                            collapse-tags
                            @change="cascadeChange($event,data)"
                            @visible-change="visibleChange($event,data)"
                        >
                        <!--  @change="
                                (val) => {
                                    cascadeChange(val, data);
                                }
                            " -->
                            <el-option
                                v-for="(val, index) in data.options"
                                :key="index"
                                :label="val.label"
                                :value="val.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="search" v-if="data.type === 'category'">
                        <slot :name="`search-${data.value}`"></slot>
                    </div>
                </el-col>
            </el-row>
        </el-col>
        <el-col v-if="!list.hideSearchBtn" :span="list.searchRightSpan || 4">
            <slot name="table-module-btn-left"></slot>
            <template v-if="!list.hideDefaultBtn">
                <el-button
                    type="primary"
                    size="mini"
                    @click="search"
                    :loading="loading"
                    icon="el-icon-search"
                >
                    {{
                        $translate('lang.E3202101260004', {
                            defaultText: '查 询'
                        })
                    }}
                </el-button>
                <el-button
                    class="sn-search-reset-button"
                    @click="reset"
                    size="mini"
                >
                    {{
                        $translate('lang.E3202101260009', {
                            defaultText: '重 置'
                        })
                    }}
                </el-button>
                <span @click="changeSecondQueryCondition" class="packUP" v-if="list.isSearchFlag">
                    <span class="packUP_text">{{isCloseText}}</span>
                    <i class="el-icon-arrow-up" v-show="isCloseFlag"></i>
                    <i class="el-icon-arrow-down" v-show="!isCloseFlag"></i>
                </span>
            </template>
            <slot name="table-module-btn-right"></slot>
        </el-col>
    </el-row>
</template>
<script>
/**
 * @description 通用表单组件
 * @property {Object} defaultValue 默认值
 * @property {Number} searchLeftSpan 默认6，搜索栏左侧span值
 * @property {Number} searchRightSpan 默认4，搜索栏右侧span值
 * @property {Boolean} showSearchBtn 显示默认操作栏
 * @property {Boolean} hideDefaultBtn 显示默认操作按钮
 *
 * @property {Array} searchTxt
 * searchTxt 子选项通用参数：
 * @property {String} type 分类, input，可选: input, datePicker, date, select, slot, category[插槽]
 * @property {Number} span Layout布局span宽度
 * @property {String} value 关键字，[注：必传]
 * @property {Boolean} name 输入框为空时占位符
 * @property {Boolean} clearable 是否显示清除按钮
 * @property {Boolean} disabled 是否禁用
 * 后续拓展每个类型和单独的配置选项
 *
 * datePicker选项
 *  @property {Boolean} pickerOptions UI的pickoption方法
 * **/
import formatTime from '@/utils/common.js';
// import { cloneDeep } from 'lodash';
export default {
    props: {
        list: {
            type: Object,
            default() {
                return {};
            }
        },
        loading: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            isCloseFlag: true,
            isCloseText: this.$translate('lang.E3202101280015', { defaultText: '收起' }),
            searchData: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$translate('lang.E3202101270017', {
                            defaultText: '最近一周'
                        }),
                        onClick(picker) {
                            picker.$emit('pick', [
                                formatTime.initStartDate(6),
                                formatTime.initEndDate()
                            ]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270019', {
                            defaultText: '最近一个月'
                        }),
                        onClick(picker) {
                            picker.$emit('pick', [
                                formatTime.initStartDate(30),
                                formatTime.initEndDate()
                            ]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270021', {
                            defaultText: '最近三个月'
                        }),
                        onClick(picker) {
                            picker.$emit('pick', [
                                formatTime.initStartDate(90),
                                formatTime.initEndDate()
                            ]);
                        }
                    }
                ]
            }
        };
    },
    watch: {
        searchData: {
            handler(val) {
                this.$emit('onSearchDataChange', val);
            },
            deep: true
        }
    },
    created() {
        // this.reset();
        this.searchData = this.list.defaultValue ? this.list.defaultValue : {};
    },
    methods: {
        changeSecondQueryCondition() {
            this.isCloseFlag = !this.isCloseFlag;
            if (this.isCloseFlag) {
                this.isCloseText = this.$translate('lang.E3202101280015', { defaultText: '收起' });
            } else {
                this.isCloseText = this.$translate('lang.E3202101280014', { defaultText: '展开' });
            }
            this.$emit('changeSecondQueryCondition', this.isCloseFlag);
        },
        // 重置
        reset() {
            this.searchData = {};
            this.$emit('reset');
        },
        // 设置值
        setSearchData(key, value) {
            this.$set(this.searchData, key, value);
        },
        search() {
            this.$emit('search', this.searchData);
        },
        cascadeChange(key, value) {
             if (value.relevance) {
                this.searchData = {
                    ...this.searchData,
                    [value.relevance]: ''
                };
            }
            this.$emit('cascadeChange', key, value);
        },
        visibleChange(key, value) {
             if (value.relevance) {
                this.searchData = {
                    ...this.searchData,
                    [value.relevance]: ''
                };
            }
            this.$emit('visibleChange', key, value);
        }
        // cascadeChange(val, configuration) {
        //     if (configuration.iscascade) {
        //         this.$set(this.searchData, configuration.iscascadeObject, '');
        //     }
        //     this.$emit('cascadeChange', val, configuration);
        // }
        // dataInit() {
        //     const searchData = {};
        //     this.list.searchTxt.forEach((data) => {
        //         if (data.type === 'datePicker' && data.timeNum) {
        //             const today = dayjs();
        //             const startOfDay = today.startOf('day');
        //             const endOfDay = today.endOf('day');
        //             const start = data.future
        //                 ? startOfDay.toDate()
        //                 : startOfDay.subtract(data.timeNum, 'd').toDate();
        //             const end = data.future
        //                 ? endOfDay.add(data.timeNum, 'd').toDate()
        //                 : today.endOf('day').toDate();
        //             searchData[data.value] = [start, end];
        //         }
        //     });
        //     this.searchData = searchData;
        // }
    }
};
</script>
<style lang="less" scoped>
.model-table-search {
    .search-box {
        .el-date-editor--datetimerange.el-input__inner {
            width: 100%;
        }
        flex-wrap: wrap;
        .search {
            margin: 0 8px 10px 0;
        }
        .advanced-btn {
            margin-left: 10px;
        }
    }
    .text-box {
        position: relative;
        font-size: 12px;
        width: 100%;
    }
    .select-btn-box {
        display: flex;
        .blueBtV3 {
            margin-right: 10px;
        }
    }
    .el-autocomplete,
    .el-select {
        width: 100%;
    }
    .search-box-datePick {
        width: 100%;
    }
    /deep/ .el-range-input {
        text-align: left;
    }
    .packUP{
        margin-left: 10px;
        cursor: pointer;
        .packUP_text{
            margin-right: 3px;
            font-size: 14px;
            color: #4285f5;
        }
    }
}
</style>
